const facetInteractionDataLayer = (
  member,
  value,
  stepMembers,
  sessionData,
  isCommit
) => {
  var members = stepMembers;
  let currentMember;
  let selectedMember;
  let currentValue;

  if (members?.length > 0 && member) {
    currentMember = members.filter(x => x && x?.name == member?.name);
    if (currentMember.length > 0) {
      selectedMember = currentMember[0];
    } else selectedMember = member;

    currentValue = isCommit ? value : selectedMember?.value;

    var subCategory = selectedMember.domain.elements.filter(
      x => x?.name === currentValue
    );
    var sub_category_pos = selectedMember.domain.elements.findIndex(
      x => x?.name === currentValue
    );
    let index = getIndex(stepMembers, member);
    if (index > -1) {
      window['dataLayer'].push({
        event: 'facet_products',
        facet_category: member.description,
        facet_category_pos: index,
        facet_sub_category:
          subCategory.length > 0 ? subCategory[0].description : 'N/A',
        facet_sub_category_pos:
          sub_category_pos >= 0 ? sub_category_pos : 'N/A',
        product_category_name: sessionData.breadCrumbText2
          ? sessionData.breadCrumbText2
          : 'N/A',
        product_series_name: sessionData.seriesName,
        product_series_id: sessionData.productId
      });
    }
  }
};

const SetCommitsName = (commitsName, memberDescription, index, startData) => {
  if (commitsName && commitsName.length > 0) {
    if (!commitsName.includes(memberDescription + '!' + index)) {
      let commitsBuilder = '';
      let isIndexExist = false;
      if (startData.isManifoldProduct) {
        let allCommits = commitsName.split('|');
        allCommits.forEach(item => {
          let commit = item.split('!');

          if (commit.length > 1) {
            if (parseInt(commit[1]) == index) {
              commit[0] = memberDescription;
              isIndexExist = true;
            }

            if (commitsBuilder == '') {
              commitsBuilder = commit[0] + '!' + commit[1];
            } else {
              commitsBuilder += '|' + commit[0] + '!' + commit[1];
            }
          }
        });
      }

      if (isIndexExist) commitsName = commitsBuilder;
      else commitsName += '|' + memberDescription + '!' + index;
    }
  } else commitsName = memberDescription + '!' + index;

  return commitsName;
};

const RemoveCommitsName = (commitsName, memberDescription) => {
  if (commitsName) {
    let commitsAfterReplace = commitsName.replace(memberDescription, '');
    let commitsAfterUncommit = commitsAfterReplace.split('|');
    let remainingCommits = [];

    if (commitsAfterUncommit.length > 0) {
      commitsAfterUncommit.forEach(item => {
        let commit = item.split('!');
        if (commit[0].length > 0) {
          remainingCommits.push(item);
        }
      });
    }

    return remainingCommits.filter(x => x).join('|');
  }
};

const getIndex = (stepMembers, member) => {
  return stepMembers?.findIndex(x => x && x?.name == member?.name);
};

export {
  facetInteractionDataLayer,
  SetCommitsName,
  RemoveCommitsName,
  getIndex
};
